export const EMAILJS_CONFIG = {
  SERVICE_ID: "service_zt41tjs",
  TEMPLATE_ID: "template_1chhqc8",
  PUBLIC_KEY: "mVSGM1k3woUo_LPb3",
};
